import { render, staticRenderFns } from "./Receptor.vue?vue&type=template&id=c6b96aa4&"
import script from "./Receptor.vue?vue&type=script&lang=js&"
export * from "./Receptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports